import React from "react";
import { Heading, SimpleGrid } from "@chakra-ui/react";

import { NewItemCardContent } from "./newModuleTypes";
import { NewItemCard } from "./NewItemCard";

type NewItemListProps = {
  title: "sensor" | "hybrid";
  startPoints: NewItemCardContent[];
};

/**
 * A component to display a list of "starting points" for various module types.
 * @param {string} title Title to display which subcomponent of module is being created.
 * @param {NewItemCardContent} startPoints Array of objects that define the different ways to "start" a module
 * @returns
 */
export function NewItemList({ title, startPoints }: NewItemListProps) {
  return (
    <>
      <Heading as="h3" marginTop="8px">
        Start a new {title}
      </Heading>
      <SimpleGrid columns={{ sm: 2, md: 3 }} spacing="8px">
        {startPoints.map(({ name, step, moduleTag }) => (
          <NewItemCard
            key={name}
            name={name}
            step={step}
            moduleTag={moduleTag}
          />
        ))}
      </SimpleGrid>
    </>
  );
}
